import permissions from 'constants/permissions'

const QUESTIONNAIRE_LIST = [
  {
    name: 'Visualizar',
    tag: permissions.QUESTIONNAIRES.VIEW,
  },
  {
    name: 'Gerenciar',
    tag: permissions.QUESTIONNAIRES.MANAGE,
  },
]

export default QUESTIONNAIRE_LIST
